module.exports = __webpack_public_path__ + "img/productInspection.feb32416.svg";